import { SelectProduct, StylingStaff } from "../types/salon.types";

export const buildOrderData = ({
  customerId,
  staff,
  products,
  totals,
  customer,
  payment,
  discount,
  tips,
  time,
  outstandingBalance,
}: {
  customerId: string;
  staff: StylingStaff | null;
  products: SelectProduct[];
  totals: { subtotal: number; total: number };
  customer: { Name: string; phone_number: string };
  payment: { method: string; received: number; isFullPayment: boolean };
  discount: string;
  tips: string;
  time: any;
  outstandingBalance: number;
}) => {
  return {
    Customerid: customerId,
    staffname: staff?.staff_name,
    staffId: staff?._id.$oid,
    Products: products.map((p) => ({
      id: p._id.$oid,
      name: p.ProductName,
      amount: p.Amount,
      quantity: p.quantity || 1,
      totalPrice: Number(p.Amount) * Number(p.quantity),
    })),
    totalAmount: totals.subtotal.toFixed(2),
    Finalamount: totals.total.toFixed(2),
    Orderdate: `${time.year}-${time.month}-${time.day}`,
    Ordertime: `${time.hours}:${time.minutes}`,
    customer,
    tips,
    discount,
    OrderStatus: "Confirm",
    RemainingAmount:
      payment.method === "Buy on credit" ? totals.total.toFixed(2) : payment.isFullPayment ? "0" : (totals.total - payment.received).toFixed(2),
    paymentHistory: [
      {
        Paymentmethod: payment.method,
        ReceivedAmount: payment.method === "Buy on credit" ? "0" : payment.received.toFixed(2),
      },
    ],
    payments: [
      {
        Paymentmethod: payment.method,
        ReceivedAmount: payment.method === "Buy on credit" ? "0" : payment.received.toFixed(2),
      },
    ],
    changeDue: payment.method === "Buy on credit" ? "0" : payment.isFullPayment ? (payment.received - totals.total).toFixed(2) : "0",
    outstanding_balance: outstandingBalance,
    cancel_order_amount: "0",
    paymentStatus: payment.method === "Buy on credit" ? "credit" : payment.isFullPayment ? "paid" : "partial",
  };
};
